/**
 * Que tipo de ponteiro está operando a tela.
 *
 * Existe porque algumas decisões não dão para resolver no CSS: `draggable` é
 * atributo do HTML, e arrastar-e-soltar nativo simplesmente não acontece no
 * toque — o navegador nunca dispara `dragstart` com o dedo. Marcar o cartão
 * como arrastável no celular não habilita nada e ainda atrapalha, porque o
 * navegador passa a tratar o primeiro toque como possível início de arraste em
 * vez de clique.
 *
 * Reativo de propósito: um tablet com teclado acoplado troca de ponteiro no
 * meio da sessão, e um valor lido uma vez na montagem ficaria mentindo.
 */
import { useEffect, useState } from 'react';

const CONSULTA = '(pointer: coarse)';

export function usePonteiroGrosso(): boolean {
  const [grosso, setGrosso] = useState(() => {
    // `matchMedia` não existe na renderização fora do navegador; sem o guarda,
    // qualquer render no servidor quebraria antes de chegar à tela.
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(CONSULTA).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const consulta = window.matchMedia(CONSULTA);
    const aoTrocar = (): void => setGrosso(consulta.matches);

    aoTrocar();
    consulta.addEventListener('change', aoTrocar);
    return () => consulta.removeEventListener('change', aoTrocar);
  }, []);

  return grosso;
}
